import { ConfirmDialog } from '@/components/common/ConfirmDialog';
import { formatCount } from '@/utils/number';
import { useDeleteRole } from '../hooks/useDeleteRole';
import type { Role } from '../types/role.types';

interface RoleDeleteConfirmationProps {
  role: Role | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function RoleDeleteConfirmation({ role, open, onOpenChange }: RoleDeleteConfirmationProps) {
  const { mutate, isPending } = useDeleteRole();

  function handleConfirm() {
    if (!role) return;
    mutate(role.id, { onSuccess: () => onOpenChange(false) });
  }

  const description = role
    ? role.assignedUserCount > 0
      ? `"${role.name}" is held by ${formatCount(role.assignedUserCount, 'user')} and cannot be deleted. Set its status to Inactive instead.`
      : `"${role.name}" will be removed. A role held by any user can't be deleted - set its status to Inactive instead.`
    : '';

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Delete role?"
      description={description}
      confirmLabel="Delete"
      confirmVariant="destructive"
      isPending={isPending}
      pendingLabel="Deleting..."
      onConfirm={handleConfirm}
    />
  );
}
